import { Mode } from "./mode.js";

export const setSettled = () => Mode.set("isSettled");
